import { Group, Loader, Paper, Stack, Text } from '@mantine/core'
import { IconCheck, IconPoint } from '@tabler/icons-react'
import { ESPECIALISTAS, friendlyToolLabel, respondeuDaPorta } from '../toolLabels'
import { agruparPassos, type PassoAoVivo } from '../passosAoVivo'

interface LiveAssistantBubbleProps {
  /** Passos já dados neste turno (na ordem), para mostrar o raciocínio ao vivo. */
  steps: PassoAoVivo[]
}

function rotuloDoPasso(p: PassoAoVivo): string {
  const respondeu = p.fim ? respondeuDaPorta(p.name) : null
  return respondeu ?? friendlyToolLabel(p.name)
}

/**
 * Bolha ao vivo do @Atendente enquanto ele raciocina: lista os passos de
 * ferramenta conforme acontecem ("acompanhar o raciocínio") e um indicador
 * "…digitando" enquanto processa. Os passos de um especialista (o que a porta
 * dele — `consultar_devops`, `consultar_dba` — rodou por dentro) aparecem
 * recuados sob a linha dela.
 */
export function LiveAssistantBubble({ steps }: LiveAssistantBubbleProps) {
  const grupos = agruparPassos(steps)
  return (
    <Group justify="flex-start" gap="xs" aria-live="polite">
      <Paper withBorder radius="lg" px="md" py="xs" bg="var(--ai-bg-elevated)">
        <Stack gap={4}>
          {grupos.map(({ passo, dentro }, i) => (
            <Stack key={`${passo.name}-${i}`} gap={2}>
              <Group gap={6} wrap="nowrap">
                <IconCheck size={14} color="var(--mantine-color-teal-6)" aria-hidden />
                <Text size="sm" c="dimmed">
                  {rotuloDoPasso(passo)}
                </Text>
              </Group>
              {dentro.length > 0 && (
                <Stack component="ul" gap={2} pl="lg" m={0}
                  aria-label={`Passos do ${dentro[0].agente === 'atendente' ? '@Atendente' : ESPECIALISTAS[dentro[0].agente].nome}`}
                  style={{ listStyle: 'none' }}>
                  {dentro.map((d, j) => (
                    <Group component="li" key={`${d.name}-${j}`} gap={6} wrap="nowrap">
                      <IconPoint size={12} color="var(--mantine-color-dimmed)" aria-hidden />
                      <Text size="xs" c="dimmed">
                        {friendlyToolLabel(d.name)}
                      </Text>
                    </Group>
                  ))}
                </Stack>
              )}
            </Stack>
          ))}
          <Group gap="xs" wrap="nowrap">
            <Loader size="sm" type="dots" color="teal" />
            <Text size="sm" c="dimmed">
              {steps.length > 0
                ? 'Estou trabalhando nisso…'
                : 'Estou preparando sua resposta…'}
            </Text>
          </Group>
        </Stack>
      </Paper>
    </Group>
  )
}
